import { connect } from 'react-redux';
import Reporting from '../../components/reporting';

import {
    toggleModalReporting,
    toggleReportingFilters,
    fetchReportingDataThunk,
    reportingCategory,
    onLoadReportingLocations,
    toggleGenerateModalReporting
} from '../../actions';

import {
    getReportingCategoryList,
    getReportingData,
    getReportingLoading
} from '../../reducers';

const mapStateToProps = state => ({
    userInfo: state.data.userInfo,
    startDate: state.reportingFilters.startDate,
    endDate: state.reportingFilters.endDate,
    jwtToken: state.auth.jwtToken,
    modalReporting: state.ui.modalReporting,
    modalGenerateReporting: state.ui.modalGenerateReporting,
    data: getReportingData(state),
    reportingFiltersActive: state.reporting.reportingFiltersActive,
    reportingCategoryList: getReportingCategoryList(state),
    getReportingLoading: getReportingLoading(state)
});

const mapDispatchToProps = dispatch => ({
    onLoadReportingLocations: model =>
        dispatch(onLoadReportingLocations(model)),
    toggleModalReporting: () => dispatch(toggleModalReporting()),
    toggleGenerateModalReporting: () =>
        dispatch(toggleGenerateModalReporting()),
    toggleReportingFilters: loading =>
        dispatch(toggleReportingFilters(loading)),
    reportingCategory: () => dispatch(reportingCategory()),
    fetchReportingResults: () => dispatch(fetchReportingDataThunk())
});

export default connect(mapStateToProps, mapDispatchToProps)(Reporting);



// WEBPACK FOOTER //
// ./src/containers/reporting/index.js